// extracted by mini-css-extract-plugin
export var deliveryRow = "_qe-a";
export var fixedHeight = "_qe-4";
export var freightLogo = "_qe-9";
export var fullWidth = "_qe-3";
export var priceColumn = "_qe-5";
export var radioSelected = "_qe-7";
export var radioUnselected = "_qe-6";
export var selectedOption = "_qe-2";
export var selectedOptionContainer = "_qe-1";
export var selection = "_qe-0";
export var tallSkeletonText = "_qe-8";